import React from 'react';
import './Header.css';
// import logoMel from '../asset/image/Logo_Mel_transp.png';

const Header = () => {
  return (
    <header>
      <div className='LogoTitreCamion'>
        {/* <div className='logoTitreHeader'>
          <img src={logoMel} alt="logoMel" className='logoMel'/>
          <h1 className='titreHeader'>Les Tontons Friteurs</h1>
        </div> */}
        {/* <img src={camionImage} alt="Camion" className='camionHeader' /> */}
      </div>
    </header>
  );
};

export default Header;
